module.exports = __webpack_public_path__ + "img/icon-lock-pink-quest-dark.2f9e167d.svg";